export const SignUpProvider = {
  GOOGLE: 'google',
  GITHUB: 'github',
  EMAIL: 'email',
  ACCESS_TOKEN: 'access_token',
} as const;
export type SignUpProvider =
  (typeof SignUpProvider)[keyof typeof SignUpProvider];

export const GITHUB_CLIENT_ID = import.meta.env.VITE_GITHUB_CLIENT_ID;
export const REDIRECT_URI = import.meta.env.VITE_GITHUB_REDIRECT_URI;
export const GITHUB_URL = import.meta.env.VITE_GITHUB_URL;
export const SCOPE = import.meta.env.VITE_GITHUB_SCOPE;

export const GOOGLE_CLIENT_ID = import.meta.env.VITE_GOOGLE_APP_ID;
export const GOOGLE_REDIRECT_URI = import.meta.env.VITE_GOOGLE_REDIRECT_URI;
export const GOOGLE_SCOPE = import.meta.env.VITE_GOOGLE_SCOPE;
export const GOOGLE_RESPONSE_TYPE = 'code';

export const SIGN_UP_DATA_TEST_ID_PREFIX = 'sign-up';

export const SIGNUP_STEPS = {
  // Step 0: Initialization
  INITIALIZATION: { step: 0, name: 'initialization' },
  DOWNLOAD: { step: 0, name: 'download' },

  // Step 1: Authentication
  PROVIDER_SELECT: { step: 1, name: 'provider_select' },
  OAUTH_CALLBACK: { step: 1, name: 'oauth_callback' },
  EMAIL_PASSWORD: { step: 1, name: 'email_password' },
  EMAIL_VERIFICATION: { step: 1, name: 'email_verification' },

  // Step 2: User Information
  USER_INFO: { step: 2, name: 'user_info' },

  // Step 3: Registration (either user joins existing tenant OR creates new tenant)
  USER_REGISTRATION: { step: 3, name: 'user_registration' },
  TENANT_REGISTRATION: { step: 3, name: 'tenant_registration' },

  // Step 4: Completion
  COMPLETED: { step: 4, name: 'completed' },
} as const;
